import React, { useState, useEffect, useContext } from "react";
import Theme from "../../util/globals/Theme";
import { Link } from "gatsby";
import arrowWhiteDown from "../../assets/icon-colors/base-icons/arrow-white-down.svg";
import arrowLeft from "../../assets/icon-colors/base-icons/arrow-left.svg";
import selectCondition from "../../assets/images/select-condition.svg";
import rightChevron from "../../assets/images/right-chevron.svg";

import Helmet from "react-helmet";
import FocusTrap from "focus-trap-react";
import styled from "styled-components";
// Components
import HeaderLink from "./HeaderLink";
import NavigationLayout from "../NavigationLayout";

// Styles
import * as s from "./styles";
import Button from "../Button";
import NavigationDropDown from "../NavigationDropDown";

// Copy
import headerCopy from "../../copy/header";
import { respondTo } from "../../styles/shared/breakpoints";

//context
import SelectIndicationContext from "../../context/SelectIndicationContext";

//header
import { HeaderCancerSelection } from "./HeaderCancerSelection";

const ModalAlert = ({ link, onClose }) => {
  const handleConfirm = () => {
    if (!link.match(/^https?:\/\//i)) {
      link = "http://" + link;
    }
    window.open(link, "_blank");
    onClose();
  };

  return (
    <s.ModalPopUp>
      <FocusTrap>
        <s.ModalContent tabIndex="1">
          <s.ModalClose
            onClick={onClose}
            title="stay on current site and close this modal"
          >
            CLOSE
          </s.ModalClose>
          <p>
            You will now be leaving this site and will be redirected to the
            Merck Medical Portal.
          </p>
          <p>
            The Merck Medical Portal is for health care professionals in the US
            and its territories only.
          </p>
          <s.LightBlueButton
            variant="primary"
            className={"modal-button"}
            tabIndex="0"
            title="confirm you want to move to another website"
            onClick={handleConfirm}
          >
            Continue
            <s.ArrowWhiteBtn />
          </s.LightBlueButton>
        </s.ModalContent>
      </FocusTrap>
    </s.ModalPopUp>
  );
};

const Header = ({ pageKey, location, isOrphan, isMed, isMob }) => {
  const [navOpen, setNavOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { selectIndication, setSelectIndication } = useContext(
    SelectIndicationContext
  );

  const [showModal, setShowModal] = useState(false);
  const [modalLink, setModalLink] = useState("");

  const onOverlayClick = (e) => {
    e.stopPropagation();
    setNavOpen(false);
  };

  const handleLinkClick = (e) => {
    // special "parent" case for svgs - the <a> tag is a parent to <rect> which the event passes in here
    const isExternal =
      e.target.dataset.showModal || e.target.parentNode.dataset.showModal;
    if (isExternal) {
      e.preventDefault();

      if (e.target.href) {
        setModalLink(e.target.href);
      } else if (e.target.parentNode.href.baseVal) {
        // case for <a> tags in an svg
        setModalLink(e.target.parentNode.href.baseVal);
      }
      setShowModal(true);
    }
  };

  useEffect(() => {
    const externalLinks = document.querySelectorAll('a[href^="http"]');
    externalLinks.forEach((link) => {
      link.addEventListener("click", handleLinkClick);
    });

    return () => {
      externalLinks.forEach((link) => {
        link.removeEventListener("click", handleLinkClick);
      });
    };
  }, [location]);
  const CustomWrapper = styled.div`
    display: none;
    ${respondTo.md` 
      display:inline-block;

      button {
        padding: 5px 13px;
        border-radius: 2px;
        border: 1px solid ${Theme.colors.white};
        background: var(--Primary-Brand-blue, #2e3790);
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        color: white;

        
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
      }
    `}
  `;

  const ActiveSpan = styled.span`
    &::before {
      display: inline-block;
      content: "";
      background-image: url(${arrowLeft});
      background-color: transparent;
      background-size: 100%;
      width: 6px;
      height: 10px;
      vertical-align: middle;
      background-repeat: no-repeat;
      margin-right: 5px;
    }
  `;
  const SelectSpan = styled.span`
    &::before {
      display: inline-block;
      content: "";
      background-image: url(${arrowWhiteDown});
      background-color: transparent;
      background-size: 100%;
      width: 11px;
      height: 10px;
      vertical-align: middle;
      background-repeat: no-repeat;
      margin-right: 5px;
    }
  `;

  const HeaderLinks = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 0.3125rem;
    padding-bottom: 0.3125rem;
    text-align: center;
    font-weight: 600;
    pointer-events: all;
    position: relative;
    background: var(--Gradients-Blue-Gradient, linear-gradient(90deg, #2E3790 12.56%, #3F89C8 100%));
    padding: 16px 20px;


    @media (min-width: ${Theme.breakpoints.lg}px) {
      padding: 0px
    }

              
    a,
    .indications,
    span.label {
      position: relative;
      white-space: nowrap;
      padding-left: 5px;
      padding-right: 5px;
      font-size: 9px;
      line-height: 1;
      font-weight: 600;

  `;
  const MobileChangeSection = styled(HeaderLinks)``;
  const SelectCondition = styled.div``;

  const ActiveCondition = styled.div`
    display: flex;
    align-items: center;
    // max-width: 300px;
    font-size: 12px;
    line-height: 1;
    font-weight: 600;
    justify-content: space-between;
    width: 100%;

    p {
      a {
        color: ${Theme.colors.white};
        
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%; /* 20.8px */
        text-decoration: none;
      }
    }
    span {
      a {
        
        width: 300px;
        color: white;
        &:hover {
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }

    .no-pad {
      padding: 0 0 0 0;
    }

    button {
      margin-left: 18px;
      line-height: normal;
      overflow: visible;
      width: auto;
      margin: 0;
      padding: 0;
      
      border: none;
      background: transparent;
      position: relative;
      font-size: 14px;
      line-height: 1;
      flex: 0 1 auto;
      color: #444;
      border-radius: 2px;
      background-color: ${Theme.colors.white};
      font-weight: 600;
      line-height: 1.1;
      padding: 3px 7px;
      
      padding: 5px 13px;
      border-radius: 2px;
      font-size: 11px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px; /* 218.182% */
      color: #2C3796;
    }
  `;

  const Select = styled(HeaderCancerSelection)`
    position: relative;
    background: ${Theme.colors.white};
    color: ${Theme.colors.black};
    min-height: 1.9375rem;
    border-radius: 0.125rem;
    padding: 0.5rem 0.25rem;
    margin-right: auto;
    cursor: pointer;
    font-weight: 600;
    line-height: 15px;
    display: none;

    @media (min-width: ${Theme.breakpoints.lg}px) {
      padding-left: 23px;
      padding-right: 15px;
      display: flex;
      align-items: center;
    }
  `;
  const SelectAarow = styled.img`
    position: absolute;
    left: 12px;
  `;
   const NavigationWrapper = styled.div`
    @media(max-width:768px){
      max-height: 45vh;
      overflow-x: scroll;
    }
  `;
  const CustomWrapperMob = styled.div`
    button {
      display: inline-block;
      margin-left: 20px;
    }

    ul {
      position: relative;
      margin-left: 0;
      width: 100%;
      li {
        &:last-child {
          border-bottom: 0.5px solid rgb(190, 190, 190);
        }
      }
    }
    ${respondTo.md` 
    display:none;
    `}
  `;
  const handleCloseModal = () => {
    setShowModal(false);
    setModalLink("");
  };

  const handleIndicationDropdownChange = (e) => {
    window.location = e.href;
  };

  const handleDropdown = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  return (
    <>
      {(navOpen || (isOpen && isMob)) && (
        <Helmet>
          <html lang="en-us" className="no-scroll" />
        </Helmet>
      )}

      {showModal && <ModalAlert link={modalLink} onClose={handleCloseModal} />}
      <s.StyledHeader className={navOpen ? "open" : ""}>
        <s.TopNav className="top-nav">
          <s.TopNavWrapper>
            <s.TopNavLinkGroup>
              {headerCopy.utilLinks.left
                .filter((linkObj) => linkObj.keys.includes(pageKey))
                .map((linkObj, i) => (
                  <s.TopNavLink
                    key={i}
                    href={linkObj.href}
                    title={linkObj.title}
                    data-show-modal={linkObj.showModal}
                    target="_blank"
                  >
                    {linkObj.copy}
                  </s.TopNavLink>
                ))}
              {headerCopy.navLinks
                .filter(
                  (navItem) =>
                    navItem.type &&
                    navItem.type === "dropdown" &&
                    navItem.keys.includes(pageKey)
                )
                .map((navItem, i) => (
                  <CustomWrapper class="desk-main-section">
                    {isMed && (
                      <>
                        {selectIndication &&
                        (selectIndication === "rcc" ||
                          selectIndication === "vhl") ? (
                          <ActiveCondition>
                            {selectIndication === "rcc" ? (
                              <button
                                aria-expanded={isOpen}
                                onClick={() => {
                                  setIsOpen(!isOpen);
                                }}
                              >
                                <ActiveSpan>Advanced Clear Cell RCC</ActiveSpan>
                              </button>
                            ) : (
                              <button
                                aria-expanded={isOpen}
                                onClick={() => {
                                  setIsOpen(!isOpen);
                                }}
                              >
                                <ActiveSpan>VHL Disease–Associated Tumors</ActiveSpan>
                              </button>
                            )}
                          </ActiveCondition>
                        ) : (
                          <button
                            data-at="cancer-type-selector"
                            aria-expanded={isOpen}
                            onClick={() => {
                              setIsOpen(!isOpen);
                            }}
                          >
                            <SelectSpan>Select Indication</SelectSpan>
                          </button>
                        )}
                      </>
                    )}
                  </CustomWrapper>
                ))}
            </s.TopNavLinkGroup>

            <s.TopNavLinkGroupRight desktopOnly aria-label="Links">
              {headerCopy.utilLinks.right
                .filter((linkObj) => linkObj.keys.includes(pageKey))
                .map((linkObj, i) => (
                  <Button
                    role="listitem"
                    key={i}
                    variant="tertiary"
                    theme="light"
                    to={linkObj.href}
                    onClick={i === 1 ? handleLinkClick : undefined}
                    title={linkObj.title}
                    data-show-modal={linkObj.showModal}
                  >
                    {linkObj.copy}
                  </Button>
                ))}
            </s.TopNavLinkGroupRight>
          </s.TopNavWrapper>
        </s.TopNav>

        <s.HeaderBar>
          <s.HeaderBarWrapper>
            <s.LogoLink to="/">
              <img
                src={headerCopy.logoImg}
                alt={headerCopy.logoAlt}
                className="main-logo"
              />
              <div className="non-brand-logo">{headerCopy.vhlLogoText}</div>
            </s.LogoLink>

            {isMob && !navOpen && (
              <s.MobileSelectCondition
                className={navOpen ? "open" : ""}
                onClick={() => setIsOpen(!isOpen)}
              >
                <img
                  src={selectCondition}
                  alt="Description"
                  className="clickable-image"
                />
                <p className="clickable-text" style={{ textAlign: "center" }}>
                  Select a condition
                </p>
              </s.MobileSelectCondition>
            )}

            {/* <s.MobileNavOverlay isActive={navOpen} onClick={onOverlayClick} /> */}

            <s.NavTray className={navOpen ? "open" : ""}>
              <s.MobileLogoLink to="/" onClick={onOverlayClick}>
                <img
                  src={headerCopy.logoImg}
                  alt={headerCopy.logoAlt}
                  className="main-logo"
                />

                <div className="non-brand-logo">{headerCopy.vhlLogoText}</div>
              </s.MobileLogoLink>

              {isMob &&
                (selectIndication === "rcc" || selectIndication === "vhl") && (
                  <MobileChangeSection as="div">
                    {selectIndication &&
                    (selectIndication === "rcc" ||
                      selectIndication === "vhl") ? (
                      <ActiveCondition>
                        <p>
                          {selectIndication === "rcc" ? (
                            <a href="/advanced-renal-cell-carcinoma/">
                              Advanced Clear Cell RCC
                            </a>
                          ) : (
                            <a href="/von-hippel-lindau/">VHL Disease–Associated Tumors</a>
                          )}
                        </p>
                        <button
                          aria-expanded={isOpen}
                          onClick={() => {
                            setIsOpen(!isOpen);
                          }}
                        >
                          {" "}
                          Change{" "}
                        </button>
                      </ActiveCondition>
                    ) : (
                      <Select
                        data-at="cancer-type-selector"
                        aria-expanded={isOpen}
                        onClick={() => {
                          setIsOpen(!isOpen);
                        }}
                      >
                        <SelectAarow
                          width={6}
                          height={10}
                          layout="raw"
                          src={rightChevron}
                          alt=""
                        />
                        Select condition seem
                      </Select>
                    )}
                  </MobileChangeSection>
                )}
              <NavigationWrapper>
                <s.PrimaryNav>
                  {headerCopy.navLinks
                    .filter((navItem) => navItem.keys.includes(pageKey))
                    .map((navItem, i) => {
                      if (!navItem.type || navItem.type !== "dropdown") {
                        return (
                          <HeaderLink
                            key={i}
                            to={navItem.href}
                            onClick={onOverlayClick}
                            data-show-modal={navItem.showModal}
                          >
                            {navItem.label}
                          </HeaderLink>
                        );
                      }
                    })}
                </s.PrimaryNav>
                <s.MobileUtilLinks>
                  <Button
                    variant="primaryBlue"
                    externalInverted2
                    margin
                    to={headerCopy.utilLinks.right[0].href}
                    data-show-modal={headerCopy.utilLinks.right[0].showModal}
                  >
                    {headerCopy.utilLinks.right[0].copy}
                  </Button>
                  <Button
                    variant="primaryBlue"
                    externalInverted2
                    margin
                    onClick={handleLinkClick}
                    to={headerCopy.utilLinks.right[1].href}
                    data-show-modal={headerCopy.utilLinks.right[1].showModal}
                  >
                    {headerCopy.utilLinks.right[1].copy}
                  </Button>
                  <Button
                    variant="primaryBlue"
                    externalInverted2
                    margin
                    to={headerCopy.utilLinks.right[2].href}
                    data-show-modal={headerCopy.utilLinks.right[2].showModal}
                  >
                    {headerCopy.utilLinks.right[2].copy}
                  </Button>
                </s.MobileUtilLinks>
              </NavigationWrapper>
            </s.NavTray>

            {navOpen && isMob && (
              <s.MobileSelectCondition
                className={navOpen ? "open" : ""}
                aria-expanded={isOpen}
                onClick={() => setIsOpen(!isOpen)}
                id="selectImg"
              >
                <img
                  src={selectCondition}
                  alt="Description"
                  className="clickable-image "
                />
                <p className="clickable-text" style={{ textAlign: "center" }}>
                  Select a condition
                </p>
              </s.MobileSelectCondition>
            )}

            <s.HamburgerButton
              onClick={() => setNavOpen(!navOpen)}
              className={navOpen ? "open" : ""}
            >
              {navOpen
                ? headerCopy.hamburgerLabels.whileOpen
                : headerCopy.hamburgerLabels.whileClosed}
            </s.HamburgerButton>
          </s.HeaderBarWrapper>
        </s.HeaderBar>
      </s.StyledHeader>

      <NavigationLayout
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onClick={() => {
          console.log("CLICKED");
        }}
      />
    </>
  );
};

export default Header;